export const InfoIcon = ({ className }: { className?: string }) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 23 37" className={className}>
    <path
      fill="currentColor"
      d="M11 37a3 3 0 1 0 0-6 3 3 0 0 0 0 6ZM13 27H9v-2.63a6.09 6.09 0 0 1 4.23-5.73A7.001 7.001 0 0 0 18 11.8 7.08 7.08 0 0 0 11.2 5a7 7 0 0 0-5.08 2A6.93 6.93 0 0 0 4 12H0a10.91 10.91 0 0 1 3.33-7.89 11 11 0 0 1 8-3.11A11.15 11.15 0 0 1 22 11.69a11 11 0 0 1-7.49 10.74A2.08 2.08 0 0 0 13 24.37V27Z"
    />
  </svg>
)
